import createSeededNoise2D from "../../createSeededNoise2D"

export const noise2D100 = createSeededNoise2D(100)

export const noise2D200 = createSeededNoise2D(200)
